module.exports = __webpack_public_path__ + "static/img/54-2.58de734.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/54-2.jpg
// module id = LafZ
// module chunks = 0